module.exports = __webpack_public_path__ + "static/media/aws-white.23546a63.svg";